import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import Row from './Row';
import Title from '../../../Symbols/Title';
import { sortByAsNumbers } from '../../../Utils/Sorters';
import WithMore from '../../WithMore';

export const Wrapper = styled.div`
	margin: 1.5rem 0 2.5rem;

	@media (max-width: 480px) {
		margin: 0.5rem 0 1.5rem;
	}
`;


const getMaxMandates = (items) => {
	const maxActualMandates = Math.max.apply(null, items.map(item => item.actualMandates || 0))
	const maxNewSenators = Math.max.apply(null, items.map(item => item.senators || 0))
	return Math.max(maxActualMandates, maxNewSenators)
}

const MandatesTable = ({ items, final }) =>{
	const maxMandates = getMaxMandates(items)
	return (<Wrapper>
		<Title>Počet mandátů{!final && ' (dle průbežných výsledků)'}</Title>
		{items.map(item => <Row key={item.id} {...item} max={maxMandates} />)}
	</Wrapper>
	)
}
const ExpandableTable = WithMore(MandatesTable, { length: 7 })

export default class Mandates extends React.PureComponent {

	render() {
		const currentParties = this.props.parties.map(item => item.id);
		const previousOnlyParties = this.props.actualMandates.filter(item => currentParties.indexOf(item.id) < 0);
		const mandates = this.props.parties.concat(previousOnlyParties).map(item => {
			const partyMandates = this.props.actualMandates.find(man => man.id === item.id) || { actualMandates: 0, actualMandatesProposing: 0 }

			const actualMandates = partyMandates[this.props.groupBy === 'nid' ? 'actualMandatesProposing' : 'actualMandates'] || 0;
			return Object.assign(item, { actualMandates });
		}).sort(sortByAsNumbers('senators'));

		return <ExpandableTable items={mandates} final={this.props.final} />
	}
}

Mandates.propTypes = {
	parties: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number.isRequired,
		actualMandates: PropTypes.number
	})).isRequired,
	actualMandates: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number.isRequired,
		actualMandates: PropTypes.number
	})).isRequired,
	groupBy: PropTypes.oneOf(['vid', 'nid'])
}
